import React, { useState, useEffect, useRef } from 'react';
import Slider from 'react-slick';
import { useTranslation, Trans } from 'react-i18next';
import Modal from './Modal';
import team from '../../data/team';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import '../../index.css';

const TeamSlider = () => {
  const { t } = useTranslation();
  const [slidesToShow, setSlidesToShow] = useState(3);
  const sliderRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);

  useEffect(() => {
    const updateSlidesToShow = () => {
      if (window.innerWidth < 640) {
        setSlidesToShow(1);
      } else if (window.innerWidth < 992) {
        setSlidesToShow(2);
      } else {
        setSlidesToShow(3);
      }
    };

    updateSlidesToShow();
    window.addEventListener('resize', updateSlidesToShow);
    return () => {
      window.removeEventListener('resize', updateSlidesToShow);
    };
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    arrows: false,
    centerMode: false,
    centerPadding: '0',
    customPaging: (i) => (
      <div className='custom-dot'>
        <span className='dot'></span>
      </div>
    ),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
        },
      },
    ],
  };

  const handleCardClick = (member) => {
    const translatedData = {
      name: t(`team.${member.id}.name`),
      title: t(`team.${member.id}.title`),
      description: t(`team.${member.id}.description`),
    };
    setSelectedCard({ ...member, ...translatedData });
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedCard(null);
  };

  return (
    <div className='max-w-7xl mx-auto w-full'>
      <Slider {...settings} ref={sliderRef} className='pb-12'>
        {team.map((member) => (
          <div key={member.id} className='px-2'>
            <div
              className='flex flex-col items-center justify-center p-6 gap-6 h-96 bg-white shadow-lg rounded overflow-hidden text-primary-blue text-center cursor-pointer'
              onClick={() => handleCardClick(member)}
            >
              <img
                src={member.image}
                alt={member.name}
                loading='lazy'
                className='w-36 h-36 border rounded-full object-cover object-top'
              />
              <h2 className='text-xl lg:text-2xl font-medium'>{t(`team.${member.id}.name`)}</h2>
              <p className='text-lg lg:text-xl font-light'>{t(`team.${member.id}.title`)}</p>
              <a
                href={member.linkedin}
                target='_blank'
                rel='noopener noreferrer'
                className='text-2xl cursor-pointer'
              >
                {member.icon}
              </a>
            </div>
          </div>
        ))}
      </Slider>
      <Modal
        isOpen={isModalOpen}
        closeModal={closeModal}
        selectedCard={selectedCard}
      />
    </div>
  );
};

export default TeamSlider;
